import {get} from '../utils'

export default host => ({playlistId, tags, isPublic= false}) =>
  get(`${host}${isPublic ? "/public" : ""}/tags/playlist/${playlistId}?tags_ids=${tags.join(',')}`)
    .then(response => response.json())
    .then(json => json.data)